/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "step2--sprite",
  "use": "step2--sprite-usage",
  "viewBox": "0 0 21 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 24\" id=\"step2--sprite\"><path d=\"M10.5 12.275c3.068 0 5.564-2.529 5.564-5.638C16.064 3.53 13.568 1 10.5 1S4.936 3.529 4.936 6.638c0 3.108 2.496 5.637 5.564 5.637Zm0-10.725c2.769 0 5.021 2.282 5.021 5.088 0 2.805-2.252 5.087-5.021 5.087-2.77 0-5.022-2.282-5.022-5.087 0-2.806 2.253-5.088 5.022-5.088Zm5.221 12.338H5.28c-2.361 0-4.28 1.944-4.28 4.335v4.502c0 .152.122.275.271.275H19.73c.15 0 .271-.123.271-.275v-4.502c0-2.39-1.92-4.335-4.279-4.335Zm3.736 8.562h-3.393v-2.304a.273.273 0 0 0-.271-.275.273.273 0 0 0-.272.275v2.304H5.48v-2.304a.273.273 0 0 0-.272-.275.273.273 0 0 0-.271.275v2.304H1.543v-4.227c0-2.087 1.676-3.785 3.736-3.785H15.72c2.06 0 3.736 1.698 3.736 3.785v4.227Z\" fill=\"gray\" stroke=\"gray\" stroke-width=\".3\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
